import type { ApiClient } from "@/lib/api";

export const deletePlugin = async (options: {
  client: ApiClient;
  id: string;
}): Promise<void> => {
  const { client, id } = options;
  await client.delete(`/plugins/${id}`);
};
